export const soluts = [
  {
    key: 'solut-ia-souveraine',
    title: 'IA souveraine hébergée en France',
    text: 'Vos assistants d’IA générative fonctionnent dans une infrastructure française : vos données ne quittent pas l’Europe.',
    iconFamily: 'fa-solid',
    icon: 'brain',
  },
  {
    key: 'solut-assistants-metier',
    title: 'Assistants IA métier',
    text: 'Rédaction, analyse, support client, synthèse : des assistants adaptés à vos métiers et à vos procédures.',
    iconFamily: 'fa-solid',
    icon: 'robot',
  },
  {
    key: 'solut-securite',
    title: 'Sécurité & conformité',
    text: 'Données cloisonnées, chiffrement, rôles RGPD clairs et conformité aux normes françaises et européennes.',
    iconFamily: 'fa-solid',
    icon: 'lock',
  },
  {
    key: 'solut-accompagnement',
    title: 'Accompagnement & formation',
    text: 'Nous formons vos équipes, cadrions les usages et construisons avec vous une adoption durable de l’IA.',
    iconFamily: 'fa-solid',
    icon: 'graduation-cap',
  },
  {
    key: 'solut-supervision',
    title: 'Exploitation & supervision',
    text: 'Installation, mises à jour, sauvegardes et surveillance continue 24h/24 et 7j/7 par nos experts.',
    iconFamily: 'fa-solid',
    icon: 'satellite-dish',
  },
  {
    key: 'solut-evolutivite',
    title: 'Catalogue évolutif',
    text: 'De nouveaux modèles et fonctionnalités intégrés au fur et à mesure, sans changement de votre côté.',
    iconFamily: 'fa-solid',
    icon: 'arrows-rotate',
  },
]
